import APGoogleHeaderScript from './APGoogleHeaderScript';

export {
  APGoogleHeaderScript
};

export default APGoogleHeaderScript;